import { render, staticRenderFns } from "./NextVisitCellRenderer.vue?vue&type=template&id=479843e2"
import script from "./NextVisitCellRenderer.vue?vue&type=script&lang=js"
export * from "./NextVisitCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports